import React from 'react';
import {
    ServicesContainer,
    ServicesItem,
    ServicesItems,
} from './Services.styled';

import { servicesData } from './ServicesData';

export const ServicesList = ({ id }: { id: string }) => {
    return (
        <ServicesContainer id={id}>
            <div>
                <h2>What I Do</h2>
                <h4>End-to-end solutions, from concept to production.</h4>
            </div>

            <ServicesItems>
                {servicesData.map((service) => {
                    return (
                        <ServicesItem key={service.title}>
                            {service.icon}
                            <h5>{service.title}</h5>
                            <p>{service.description}</p>
                        </ServicesItem>
                    );
                })}
            </ServicesItems>
        </ServicesContainer>
    );
};

export default ServicesList;
